import { useCallback, useEffect, useMemo, useState } from 'react';

import { CALL_ACTIONS } from './../../components/buttons/callActions/callActions.constants';
import CallActions from './../../components/buttons/callActions';
import RingingSounds from './../../components/music/RingingSound';
import Timer from './../../components/timer';
import useCall from './../../hooks/customHooks/useCall';
import { useRoom } from './../../hooks/customHooks/useRoom';

import user from "./../../assets/user.svg";
import { CALL_STATES } from './../../constants';
import { BASIC_CALL_ACTIONS_CONFIG } from './../../config/callActions.config';
import { useParticipant } from './../../hooks/customHooks/useParticipant';

import styles from './callBoard.module.css';
import { ParticipantDetails } from './../../models/userDetails';

const CallBoard = ({
    userName = "Test User",
    token,
    webUrl,
    handleUpdateActiveToken,
    handleClearFrame
}) =>{

    const [activeButtonActions, setActiveButtonActions] = useState([]);

    const handleToggleActiveButtonActions = useCallback((incomingAction: string, add: boolean = true) => {
        setActiveButtonActions((previousActiveList)=>{
            if(!add){
                return previousActiveList.filter((action)=>{
                    return action !== incomingAction;
                });
            }
            return [...previousActiveList, incomingAction];
        })
    },[setActiveButtonActions]);
    

    const {activeState, handleSetActiveState} = useCall();

    const { handleSetParticipant, handleSyncAfterConnect } = useParticipant(handleToggleActiveButtonActions, handleSetActiveState, handleUpdateActiveToken, handleClearFrame);

    const { handleGetActiveRoom } = useRoom(token, webUrl, handleSetParticipant, handleSyncAfterConnect);

    useEffect(()=>{
        if(!token || !webUrl){
            console.error("Token or WebUrl not found. Cannot connect to call.");
            return;
        }

        handleGetActiveRoom();
    },[handleGetActiveRoom, token, webUrl]);

    const activeActions = BASIC_CALL_ACTIONS_CONFIG[activeState] || { buttonActions: [] };

    return (
        <div className={styles.container}>
            <div className={styles.leftContainer}>
                <div className={styles.profileContainer}>
                    <img src={user} className={styles.profileIcon} alt="User profile icon"/>
                    <div className={styles.profileDetails}>
                        <label>{(activeState || "").toLocaleUpperCase()}</label>
                        <label>{(ParticipantDetails.getInstance().getSipParticipantDetails()?.name)}</label>
                    </div>
                </div>
            </div>
            {<RingingSounds play={activeState === CALL_STATES.RINGING} />}
            <div className={styles.rightContainer}>
                {
                    activeActions.buttonActions.map((actionType)=>{
                        return (
                            <CallActions
                                key={actionType}
                                type={actionType}
                                handleToggleActiveButtonActions={handleToggleActiveButtonActions}
                                handleSetActiveState={handleSetActiveState}
                                enabled={!activeButtonActions.includes(actionType)}
                                handleUpdateActiveToken={handleUpdateActiveToken}
                                handleClearFrame={handleClearFrame}
                            />
                        );
                    })
                }
            </div>
        </div>
    )
}

export default CallBoard;